var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 12,
    viewBox: "0 0 6 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.157631 0.931497L4.76841 5.61627C4.86954 5.71849 4.92626 5.85647 4.92626 6.00026C4.92626 6.14404 4.86954 6.28202 4.76841 6.38424L0.158632 11.069C0.0575609 11.1719 0.000927448 11.3103 0.000927448 11.4545C0.000927448 11.5987 0.0575609 11.7371 0.158632 11.84C0.208006 11.8906 0.26702 11.9309 0.332193 11.9584C0.397367 11.9858 0.467383 12 0.538114 12C0.608845 12 0.678861 11.9858 0.744034 11.9584C0.809208 11.9309 0.868221 11.8906 0.917596 11.84L5.52738 7.1562C5.83029 6.84769 6 6.43261 6 6.00026C6 5.5679 5.83029 5.15282 5.52738 4.84431L0.917596 0.160533C0.868206 0.109734 0.809131 0.0693536 0.743865 0.0417802C0.678598 0.0142067 0.608466 0 0.537614 0C0.466762 0 0.39663 0.0142067 0.331364 0.0417802C0.266098 0.0693536 0.207022 0.109734 0.157631 0.160533C0.0565605 0.263384 -7.29561e-05 0.401815 -7.29561e-05 0.546015C-7.29561e-05 0.690215 0.0565605 0.828646 0.157631 0.931497Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/Arrow.13b598370866a4182a1d9644e04dc2ae.svg";
export { ForwardRef as ReactComponent };